export default "__VITE_ASSET__DrPV81F$__"